import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { Box } from '@mantine-8/core';
import { IconGripVertical } from '@tabler/icons-react';
import { type FC } from 'react';
import MantineIcon from '../../common/MantineIcon';

type Props = {
    dragHandleProps?: DraggableProvidedDragHandleProps | null;
    hovered?: boolean;
};

export const GrabIcon: FC<Props> = ({ dragHandleProps, hovered }) => (
    <Box
        {...dragHandleProps}
        style={{
            ...(hovered !== undefined && {
                visibility: hovered ? 'visible' : 'hidden',
            }),
            opacity: 0.6,
            cursor: 'grab',
            '&:hover': { opacity: 1 },
        }}
    >
        <MantineIcon color="ldGray.6" icon={IconGripVertical} />
    </Box>
);
